export const tagKeys = {
  all: () => ['tags'] as const,
  lists: () => [...tagKeys.all(), 'list'] as const,
  /** `personId` undefined ⇒ the org-wide tag list. */
  list: (personId?: string) => [...tagKeys.lists(), personId ?? 'org'] as const,
}
